import { ArrayDataSource } from './BaseDataSources';
import { ISalesperson } from '../Interfaces';

export class SalesPersonSource extends ArrayDataSource<ISalesperson> {
  public constructor() {
    super('/datasource/salespersons');
  }
}